import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { site } from '../data/site';
export function GuaranteeSection() {
  return <section className="bg-brand-cream px-4 py-16 md:py-20" data-id="element-96" data-mp="4x327s6t9bfc">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-97" data-mp="9tl2aer74llc">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full border border-brand-dark bg-brand-alt shadow-sm" data-id="element-98" data-mp="et620re6wxz4">
          <ShieldCheckIcon className="h-8 w-8 text-brand-teal" aria-hidden="true" data-id="element-99" data-mp="js0xastcgf04" />
        </div>
        <h2 className="text-2xl font-black tracking-tight text-brand-blue md:text-3xl" data-id="element-100" data-mp="nskufwdx3im9">Try It With Confidence</h2>
        <p className="mt-5 text-base leading-relaxed text-brand-gray" data-id="element-101" data-mp="slmaw8trvq7y">
          Explore the complete system and see how it fits your teaching needs. Your purchase is protected by our{' '}
          <span className="font-bold text-brand-blue" data-id="element-102" data-mp="12klcj7g4ellg">{site.guaranteeDays}-day</span> satisfaction guarantee.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-brand-gray/90" data-id="element-103" data-mp="17g0p7w2e6bga">
          If it is not the right fit, contact us within the guarantee period according to the refund policy.
        </p>
      </Reveal>
    </section>;
}